import { render, staticRenderFns } from "./GetChildrenInfo.vue?vue&type=template&id=e0d061b2&scoped=true&"
import script from "./GetChildrenInfo.vue?vue&type=script&lang=js&"
export * from "./GetChildrenInfo.vue?vue&type=script&lang=js&"
import style0 from "./GetChildrenInfo.vue?vue&type=style&index=0&id=e0d061b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d061b2",
  null
  
)

export default component.exports